<rx-banner-dismissible type="warning" data-testid="patient-not-linked-banner" [autoDismiss]="false" (dismissed)="dismissed.emit()">
	<strong>{{ 'ArtTreatments.ART.Assets.NoLinking' | translate }}</strong
	><br />
	<span>{{ 'ArtTreatments.ART.Assets.NoLinkingText' | translate }}</span>
</rx-banner-dismissible>
